import { useState } from 'react';

import { useAppSelector } from '../../../store/hooks';
import CDDQuestionsForm from '../IdentityVerification/CDDQuestionsForm';
import NINForm from '../IdentityVerification/NINForm';
import ResidentialAddressForm from '../IdentityVerification/ResidentialAddressForm';
import AdditionalDocumentsForm from './AdditionalDocumentsForm';
import AdditionalInformationType from './AdditionalInformationType';

export type TStep = 'informationType' | 'nin' | 'cdd' | 'address' | 'documents';

export default function AdditionalInformationSteps({
  close,
}: {
  close: () => void;
}) {
  const [currentStep, setCurrentStep] = useState<TStep>('informationType');

  const { value } = useAppSelector((state) => state.getDocumentRequestV2);

  if (currentStep === 'nin') {
    return <NINForm close={close} />;
  }

  if (currentStep === 'address') {
    return <ResidentialAddressForm close={close} />;
  }

  if (currentStep === 'cdd') {
    return <CDDQuestionsForm close={close} />;
  }

  if (currentStep === 'documents') {
    return (
      <AdditionalDocumentsForm
        documentRequestId={value?.data?.id ?? ''}
        documentArray={value?.data?.names ?? []}
      />
    );
  }

  return <AdditionalInformationType setCurrentStep={setCurrentStep} />;
}
